import { Component, Input } from '@angular/core'

@Component({
  standalone: false,
  selector: 'app-spinner',
  template: `<div class="se-app__section">
    <div pl-grid="align-center">
      <div pl-grid-el pl-grid="shrink@phone">
        <se-spinner se-data-size="900"></se-spinner>
      </div>
    </div>
  </div>`
})
export class SpinnerComponent {
  //
}
